import React from "react";
import ReactDOM from "react-dom";
import opsComponents from "../bundles/ops";
import { tapiContainers } from "../bundles/tapi";

window.React = React;
window.ReactDOM = ReactDOM;

declare global {
  interface Window {
    componentRender: (
      componentName: string,
      props: Record<string, unknown>,
      domEl: HTMLElement
    ) => void;
    $: JQueryStatic;
    Constants: Record<string, unknown>;
  }
}

export const componentRender = (
  componentName: string,
  props: Record<string, unknown>,
  domEl: HTMLElement
) => {
  ReactDOM.render(
    React.createElement(
      opsComponents[componentName] || tapiContainers[componentName],
      props
    ),
    domEl
  );
};

window.componentRender = componentRender;
